export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Fences',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Fences',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Fences Nível 1',
      invalid: 'Nome é obrigatório',
    },
    showAnswer: {
      label: 'Mostrar resposta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Colunas:',
    },
    rows: {
      label: 'Linhas:',
    },
    extraClues: {
      label: 'Dicas Extras:',
      tooltipLine1:
        'O algoritmo define o mínimo de dicas para o jogo ter solução única.',
      tooltipLine2:
        'Adicione dicas extras para deixar o jogo mais fácil para o usuário.',
    },
    invalidDimension:
      'Combinação inválida: Linha e Coluna não podem ser ambas pares. Pelo menos uma deve ser ímpar.',
  },
  button: {
    generate: 'Gerar Jogo',
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'fences',
  },
  status: {
    summary: '{total} dicas, sendo {base} fixas e {extra} extras',
    legendTitle: 'Legenda de cores',
    fixedClues: '{count} dicas fixas',
    extraClues: '{count} dicas extras',
    answerVisible: 'Resposta visível',
    answerHidden: 'Resposta oculta',
  },
  alert: {
    generated: 'Puzzle gerado em {duration}s!',
    generateFailed: 'Erro ao gerar o puzzle.',
    workerCritical: 'Erro crítico interno na geração.',
    gameSaved: 'Jogo salvo com sucesso!',
    workerErrors: {
      pathGenerationFailed: 'Erro ao gerar o caminho.',
    },
  },
};
